import React, { useState } from 'react';
import styles from './Select.module.scss';
import { SelectProps } from './Select.types';
import Icon from '../Icons';

const className = 'select';

const Select: React.FC<SelectProps> = ({
  className: classNameProps,
  disabled,
  name,
  hideOption = false,
  iconLeft,
  label,
  onClick,
  onChange,
  options,
  placeholder,
  ref,
  value
}) => {
  const [toggleOn, setToggle] = useState(false);

  return (
    <>
      {label && <label className={styles[className + '__label']}>
        {label}  
      </label>}
      <div className={[styles[`${className}`], classNameProps,
        disabled ? styles[`${className}__disabled`] : ''].join(' ')}
        onClick={() => {
          if (disabled) return;
          setToggle(!toggleOn);
          if (onClick) {
            onClick();
          }
        }}>
        {iconLeft && (
          <span className={styles[`${className}__icon_left`]}>
            {iconLeft}
          </span>
        )}
        <input
          className={styles[`${className}__input`]}
          disabled
          name={name}
          onClick={e => {
            setToggle(!toggleOn);
          }}
          placeholder={placeholder}
          ref={ref}
          style={{ flex: 1 }}
          type="text"
          value={options?.find(opt => opt.value === value)?.text || ''}
        />
        <button
          type="button"
          className={`${styles[`${className}__icon_right`]} 
            ${toggleOn && styles[`${className}__icon_right_active`]}`}
          style={{
            position: 'absolute',
            right: 8,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
          tabIndex={-1}
        >
          <Icon name="Chevron" />
        </button>
        {(toggleOn && !hideOption) && <div className={styles[className + '__options']}>
          {
            options?.map(option => (
              <div className={styles[className + '__options_option']}
                onClick={() => {
                  onChange({
                    target: { value: option.value }
                  } as React.ChangeEvent<HTMLInputElement>);
                }}>
                {option.text}
              </div>
            ))
          }
        </div>}
      </div>
    </>
  );
};

export default React.memo(Select);